import { render, staticRenderFns } from "./WhatWeBelieve.vue?vue&type=template&id=661f418d&scoped=true&"
import script from "./WhatWeBelieve.vue?vue&type=script&lang=js&"
export * from "./WhatWeBelieve.vue?vue&type=script&lang=js&"
import style0 from "./WhatWeBelieve.vue?vue&type=style&index=0&id=661f418d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f418d",
  null
  
)

export default component.exports